/**
 * @author maosheng
 * @describe 基础工具函数
 */
import axios from 'axios'
import { getToken } from '../api/common'
// 把下载到的图片转换为 base64
export async function getImgURLOfBase64(url: string, header: any = {}) {
  // 这里获取图片的地址，如果知道地址，直接绕过这部
  let barcodeUrl = ''
  if (!url) return ''
  Object.keys(header).forEach(key => {
    axios.defaults.headers.common[key] = header[key]
  })
  axios.defaults.timeout = 60000
  if (url && url.length === 0) return ''
  // 通过图片地址获取图片，从新获取图片
  var config: any = {
    method: 'get',
    responseType: 'blob',
    url
  }
  // 重新获取请求，获取的是base64位的图片
  try {
    const { data: result } = await axios(config)
    barcodeUrl = URL.createObjectURL(result)
  } catch (err) {
    console.log(err)
  }
  // console.log(result)
  // window.URL.revokeObjectURL(result)
  Object.keys(header).forEach(key => {
    delete axios.defaults.headers.common[key]
  })
  return barcodeUrl
}

// 获取指定名称的cookie值
export function getCookie(name: string) {
  // (^| )name=([^;]*)(;|$),match[0]为与整个正则表达式匹配的字符串，match[i]为正则表达式捕获数组相匹配的数组；
  let arr = document.cookie.match(new RegExp('(^| )' + name + '=([^;]*)(;|$)'))
  if (arr !== null) {
    // console.log(arr, '正则表达式捕获数组相匹配的数组');
    return unescape(arr[2])
  }
  return null
}

// 存储cookie值并且设置cookie过期时间
export function setCookie(key: string, value: string, expires: number) {
  let date: any = new Date()
  date.setTime(date.getTime() + expires)
  document.cookie = `${key}=${value};  expires=` + date.toGMTString()
  // console.log(document.cookie, '存储cookie值并且设置cookie过期时间');
}

export function removeCookie(cookieName: string) {
  // 删除cookie
  let date: any = new Date()
  date.setTime(date.getTime() - 10001) // 把时间设置为过去的时间，会自动删除
  document.cookie = cookieName + '=v; expires=' + date.toGMTString()
  console.log(document.cookie, '删除cookie')
}

export async function onLoad(event: any) {
  let img = event.target
  if (img.dataset['loaded']) return
  img.src = img.dataset.src
  img.dataset['loaded'] = 'loaded'
  // await getChaos()
  // let header = {
  //   abc: getCookie('abc')
  // }
  // try {
  //   let src = await getImgURLOfBase64(img.dataset['src'], header)
  //   img.src = src
  //   img.dataset['loaded'] = 'loaded'
  //   return src
  // } catch (err) {
  //   console.log(err)
  //   img.dataset['loaded'] = 'loaded'
  // }
  // img.dataset['loaded'] = 'loaded' // 给与加载完毕的图片一个标识, 防止重复请求接口
}

export async function getChaos() {
  let chaos = getCookie('chaos')
  if (!getCookie('token')) {
    return false
  }
  // if (!chaos || chaos === 'undefined') {
  //   let res = await getToken()
  //   setCookie('chaos', res.data.chaos, 10 * 60 * 1000)
  //   setCookie('abc', window.atob(res.data.chaos), 10 * 60 * 1000)
  // }
}

export const checkSrc = (str: string) => {
  return str
}
